import { $api } from "../AxiosInstance";

export class TranslationJSONService {
  static  generateTranslationsJSON() {
    return $api.get("/api/files/translations/generate");
  }
  /**
   * @param {String} langCode
   */
  static  getTranslationJSON(langCode) {
    return $api.get(`/api/files/translations/${langCode}.json`);
  }

  /**
   * @param {Object} data
   * @param {String} data.languageCode
   * @param {String} data.json
   */

  static  updateTranslationJSON(data) {
    return $api.put("/api/files/translations", data);
  }
}
